/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeContacts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Contact Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 03, 2018 - 03:35:09 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      12/03/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const CONTACT_LIST_CONTAINER_LOADED = 'CONTACT_LIST_CONTAINER_LOADED';
export const CONTACT_LIST_CONTAINER_UNLOADED = 'CONTACT_LIST_CONTAINER_UNLOADED';
export const CONTACT_LIST_TABLE_LOADED = 'CONTACT_LIST_TABLE_LOADED';
export const CONTACT_LIST_TABLE_UNLOADED = 'CONTACT_LIST_TABLE_UNLOADED';

export const CONTACT_LIST_CHANGE_GROUP = 'CONTACT_LIST_CHANGE_GROUP';
export const CONTACT_SELECT_ROW = 'CONTACT_SELECT_ROW';

export const CONTACT_ADD = 'CONTACT_ADD';
export const CONTACT_EDIT = 'CONTACT_EDIT';
export const CONTACT_DELETE = 'CONTACT_DELETE';
export const CONTACT_OPEN_WARNING = 'CONTACT_OPEN_WARNING';
export const CONTACT_CLOSE_WARNING = 'CONTACT_CLOSE_WARNING';
export const CONTACT_DELETE_DISABLE = 'CONTACT_DELETE_DISABLE';
export const CONTACT_VIEW_CHILD_ITEMS = 'CONTACT_VIEW_CHILD_ITEMS';

export const CONTACT_EDIT_CONTAINER_LOADED = 'CONTACT_EDIT_CONTAINER_LOADED';
export const CONTACT_EDIT_CONTAINER_UNLOADED = 'CONTACT_EDIT_CONTAINER_UNLOADED';
export const CONTACT_EDIT_FORM_LOADED = 'CONTACT_EDIT_FORM_LOADED';
export const CONTACT_EDIT_FORM_UNLOADED = 'CONTACT_EDIT_FORM_UNLOADED';

export const CONTACT_SET_COMPANY_SELECT = 'CONTACT_SET_COMPANY_SELECT';
export const CONTACT_EDIT_DATA_LOAD = 'CONTACT_EDIT_DATA_LOAD';

export const CONTACT_EDIT_CONTAINER_SUBMIT = 'CONTACT_EDIT_CONTAINER_SUBMIT';
export const CONTACT_EDIT_CONTAINER_CANCEL = 'CONTACT_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeContacts.js